
import {
  Paper,
  Typography,
  Box,
  Button,
  Container,
} from "@mui/material";

import { Link } from "react-router-dom";

export default function ChangeDemandsCTA() {

  return (
    <Container>

      <div
        style={{
          height: "800px",
        }}
        className="hello_image"
      >

        <div className="medicines_page">
          <Paper
            sx={{
              bgcolor: "#E8E8E8",
              p: 0,
              mt: { xs: 4, sm: 6, md: 8 },
              mb: 4,
              borderRadius: "16px",
              position: "relative",
              minHeight: { xs: "auto", md: "400px" },
            }}
            className="Rxpose-box"
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                position: "relative",
                width: "100%",
                height: { xs: "500px", sm: "450px", md: "420px", lg: "420px" },
              }}



              className="inner_Rxpose-box"
            >
              <Box
                sx={{
                  width: { xs: "100%", md: "60%" },
                  padding: { xs: "32px 24px", md: "48px 0 48px 48px" },
                  order: { xs: 2, md: 1 },
                }}
                className="Rxpose-content"
              >
                <Typography
                  sx={{
                    fontSize: { xs: "30px", sm: "45px" },
                    fontWeight: 900,
                    color: "#2D3748",
                    mb: { xs: 2, md: 3 },
                    lineHeight: 1.2,
                    maxWidth: "500px",
                  }}
                >
                  Change doesn't happen unless someone demands it.
                </Typography>

                <Typography
                  sx={{
                    color: "#122C3A",
                    fontSize: { xs: "16px", sm: "18px", md: "20px" },
                    mb: 3,
                    lineHeight: 1.5,
                    maxWidth: "440px",
                  }}
                >
                  Be that someone today.
                </Typography>

              </Box>

              <Box
                sx={{

                  width: { xs: "100%", sm: "70%", md: "40%" },
                  height: "545px !important",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  order: { xs: 1, md: 2 },
                  mt: { xs: 2, md: 0 },
                }}
                className="Rxpose-image"
              >
                <img
                  src="/images/druglogos.png"
                  alt="Person viewing medication"
                  style={{
                    width: "120%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                />
              </Box>
            </Box>
          </Paper>
        </div>
      </div>
    </Container>
  );
}